import React from "react";

const features = [
  {
    title: "Best Price Guarantee",
    description:
      "Enjoy unbeatable prices on luxury and affordable stays—transparent pricing.",
  },
  {
    title: "Premium & Affordable Accommodations",
    description:
      "From luxurious escapes to budget–friendly comforts, we offer stays to suit every style and budget.",
  },
  {
    title: "Quick & Trusted Reservation Process",
    description:
      "Quick and easy bookings with reliable, secure payment methods.",
  },
  {
    title: "24/7 Customer Support",
    description:
      "Need assistance? Our support team is available anytime, anywhere.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="px-4 py-10 md:px-16 lg:px-24">
      <div className="mx-auto flex flex-col items-center gap-12 lg:flex-row lg:items-start">
        {/* Left content (heading + paragraph, always visible) */}
        <div className="max-w mx-auto w-full text-left lg:mx-0 lg:w-1/2 lg:max-w-[90%]">
          <div className="mb-4 flex items-center justify-start">
            <div className="mr-3 h-2.5 w-2.5 rounded-full bg-orange-500"></div>
            <h3 className="text-lg font-semibold text-gray-700">
              Why Choose Makku?
            </h3>
          </div>

          <h2 className="mb-6 text-3xl font-bold text-gray-900 md:text-4xl">
            The Stay You Deserve: Here’s Why Travelers Choose Makku?
          </h2>

          <p className="text-gray-600 lg:mb-10">
            Experience effortless booking, exceptional value, and premium
            accommodations. Discover why discerning travelers choose Makku for
            their perfect stay.
          </p>

          {/* Features on left side only on large screens */}
          <div className="max-w hidden space-y-6 lg:block">
            {features.map((feature, idx) => (
              <article
                key={idx}
                role="region"
                aria-label={feature.title}
                tabIndex={0}
                className="border-transparent cursor-pointer rounded-xl border-l-4 bg-white p-6 shadow-md transition-shadow duration-300 hover:border-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <h4 className="mb-1 text-lg font-semibold text-gray-900 transition-colors hover:text-indigo-700">
                  {feature.title}
                </h4>
                <p className="text-gray-600">{feature.description}</p>
              </article>
            ))}
          </div>
        </div>

        {/* Image container */}
        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://upload.wikimedia.org/wikipedia/en/2/2a/Burj_Al_Arab%2C_Dubai%2C_by_Joi_Ito_Dec2007.jpg"
            alt="Burj Al Arab"
            className="h-[90%] w-[full] rounded-3xl object-cover lg:h-[50%] lg:w-[50%]"
          />

          {/* Features overlay inside image for small/medium, outside on large */}
          <div
            className={`
              absolute inset-0 flex flex-col justify-start space-y-6 bg-black bg-opacity-20 p-6
              lg:hidden`}
          >
            {features.map((feature, idx) => (
              <article
                key={idx}
                role="region"
                aria-label={feature.title}
                tabIndex={0}
                className="
                  border-transparent cursor-pointer rounded-xl border-l-4 bg-white bg-opacity-90 p-4 shadow-md transition
                  hover:border-indigo-700 hover:shadow-lg
                  focus:outline-none focus:ring-2
                  focus:ring-indigo-500 lg:bg-white lg:bg-opacity-100
                "
              >
                <h4 className="mb-1 font-semibold text-indigo-900 transition-colors hover:text-indigo-700">
                  {feature.title}
                </h4>
                <p className="text-indigo-800">{feature.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
